<template lang="html">
  <div>

    <div class="map-popup-image" v-show="imgSrc != false">
      <img :src="imgSrc">
    </div>

    <div class="map-popup-content">

      <div class="map-popup-name font-weight-bold">{{ feature.name }}</div>

      <div class="map-popup-tags">
        <span v-if="featureTags.length != 0">
          <template v-for="(tag,index) in featureTags">
            <a :href="'/tag/'+tag.id" :class="{'font-weight-bold' : index == 0 }">{{ tag.name }}<span v-if="index+1 < featureTags.length">, </span></a>
          </template>
        </span>
      </div>

      <div class="see-more" v-if="showSeeMore" @click="goToPlacePage">
        <span class="material-icons">keyboard_arrow_right</span><br>
        <span>Se mere</span>
      </div>

      <div class="map-popup-light-content" v-show="lightContent != false" v-html="lightContent"></div>
    </div>

    <div class="bottom-bar row no-gutters">
      <div class="col-4 blue-text" @click="goToDirections">
        <span class="material-icons">directions</span><br>
        <strong><span>Rute til</span></strong>
      </div>
      <div class="col-4 blue-text" @click="likeController">
        <span :class="['material-icons', 'like-icon-i', [isLiked ? 'pink-text' : 'blue-text']]">favorite_border</span><br>
        <strong><span>Favorit</span></strong>
      </div>
      <div class="col-3 blue-text hidden">
        <span :class="['material-icons', 'like-icon-i', [isInGroup ? 'pink-text' : 'blue-text']]">playlist_add</span><br>
        <strong><span>Samling</span></strong>
      </div>
      <div class="col-4 blue-text" @click="shareItem">
        <span class="material-icons">share</span><br>
        <strong><span>Del</span></strong>
      </div>
    </div>

  </div>
</template>

<script>
import DataFunctions from '@/assets/DataFunctions.js'
import Dato from '@/assets/Dato.js'
import ContentController from '@/assets/ContentController.js'
import Router from '@/router/index.js'
import Profile from '@/assets/profile/Profile.js'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      primaryTag: false,
      imgSrc: false,
      featureTags: [],
      lightContent: false,
      showSeeMore: false,
      isLiked: false,
      isInGroup: false,
    }
  },
  props: {
    feature: {},
  },
  created() {
    DataFunctions.findPrimaryTag(this.feature).then((primaryTag) => {
      this.primaryTag = primaryTag;
      //Check for temp image
    	if(this.feature.properties.prop117 && this.feature.properties.prop108) {
    		if(this.feature.properties.prop117.value != null && this.feature.properties.prop117.value != undefined && this.feature.properties.prop117.value != 0) {
    			var from = new Date(this.feature.properties.prop117.value.from);
    			var to = new Date(this.feature.properties.prop117.value.to);
    			if(from.getTime() < Dato.today.getTime() && Dato.today.getTime() < to.getTime()) {
            this.imgSrc = 'https://apps.odenserundt.dk/media/images/640/'+this.feature.properties.prop108.value[0].src;
    			}
    		}
    	}
    	else if(this.feature.properties.prop25) {
        this.imgSrc = 'https://apps.odenserundt.dk/media/images/640/'+this.feature.properties.prop25.value[0].src;
    	}

      this.lightContent = ContentController.generateLightContent(this.feature, 'span', false);

      this.featureTags.push({id: primaryTag.id, name: primaryTag.name});
      for(var i in this.feature.tags) {
        if(this.feature.tags[i].id == primaryTag.id) {
          continue;
        }
        this.featureTags.push({id: this.feature.tags[i].id, name: this.feature.tags[i].name});
      }

      // see more - Dont show if already on page
    	var currentPlaceId = window.location.href.split('/');
    	if(currentPlaceId[currentPlaceId.length -1] != this.feature.id) {
    		this.showSeeMore = true;
    	}

      if(Profile.loggedIn) {
        this.isLiked = Profile.checkIfItemIsLiked('place', this.feature.id);
        this.isInGroup = Profile.checkIfItemIsInUserGroup('place', this.feature.id);
      }
    });
  },
  mounted() {

  },
  methods: {
    goToPlacePage() {
      Router.push('/tag/'+this.primaryTag.id+'/place/'+this.feature.id);
    },
    goToDirections() {
      Router.push('/directions/place/'+this.primaryTag.id+','+this.feature.id);
    },
    likeController() {
      if(Profile.loggedIn) {
        this.likeOptions = {type: 'place', id: this.feature.id, name: this.feature.name, tagId: this.primaryTag.id, img: this.imgSrc};
        var isLiked = Profile.checkIfItemIsLiked('place', this.feature.id);
        if(!isLiked) {
          Profile.like(this.likeOptions);
          this.isLiked = true;
        }
        else if(isLiked) {
          var obj = {message: 'Vil du fjerne '+this.feature.name+' fra dine favoritter?', cancelBtnText: 'Nej', btnText: 'Ja', callbackType: 'function', callback: this.unlikeDone};
          EventBus.$emit('openMessageBox', obj);
        }
      }
      else {
        Router.push('/login');
      }
    },
    unlikeDone() {
      Profile.unlike('place', this.feature.id);
      this.isInGroup = Profile.checkIfItemIsInUserGroup('place', this.feature.id);
      this.isLiked = false;
    },
    addItemToUserGroup() {
      if(Profile.loggedIn) {
        this.$emit('addItemToUserGroup');
      }
      else {
        Router.push('/login/explain');
      }
    },
    shareItem() {
      EventBus.$emit('openShareBox', {name: this.feature.name, type: 'place', tagId: this.primaryTag.id, id: this.feature.id });
    },
  }
}
</script>

<style lang="css" scoped>
  .map-popup-image img {
  	max-width: 100%;
  }

  .map-popup-content {
    min-height: 100px;
    padding: 5px;
  }

  .map-popup-name {
  	font-size: 14px;
  }

  .map-popup-tags {
    margin-top: 5px;
  	margin-bottom: 5px;
  	width: 75%;
  	display: inline-block;
  }

  .map-popup-light-content {
    margin-top: 5px;
    padding: 5px 5px 5px 0px;
  	width: 75%;
  	display: inline-block;
  	vertical-align: top;
  }

  .map-popup-light-content p {
  	margin: 0;
  }

  .see-more {
    position: absolute;
  	right: 0px;
    width: 25%;
  	display: inline-block;
  	text-align: center;
  	line-height: 10px;
    cursor: pointer;
  }

  .see-more .material-icons {
  	font-size: 38px !important;
  }

  .bottom-bar {
  	padding-top: 3px;
    padding-bottom: 3px;
  	text-align: center;
  	border-top: 1px solid #e1e1e1;
  	font-size: 11px;
  	font-family: 'Roboto Condensed', sans-serif;
  }

  .bottom-bar div {
    cursor: pointer;
  }

  .close-btn {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 30px;
    height: 30px;
    border: 1px solid #ddd;
    border-radius: 666px;
    text-align: center;
    font-size: 20px !important;
    padding-top: 4px;
    background-color: #f8f8f8;
    cursor: pointer;
  }
</style>
